import PaginazioneTitoloPulsanteCrea from "../riutilizabili/PaginazioneTitoloPulsanteCrea";

export default function ViewMovimenti() {
    return (
        <div className='p-2'>
           <PaginazioneTitoloPulsanteCrea titolo={'Movimentazione articoli'}   />
        </div>
    )
}